
import { SortValue } from '@/types/used-cars/used-cars.types';

export function normalizeSort(sort?: string): SortValue {
  switch (sort) {
    // ----- legacy Directus values -----
    case 'display_price':
      return SortValue.PRICE_ASC;

    case '-display_price':
      return SortValue.PRICE_DESC;

    case 'mileage':
      return SortValue.MILEAGE_ASC;

    case '-mileage':
      return SortValue.MILEAGE_DESC;

    case 'year':
      return SortValue.YEAR_ASC;

    case '-year':
      return SortValue.YEAR_DESC;

    // ----- new Algolia values (already normalized) -----
    case SortValue.LATEST:
      return SortValue.LATEST;

    case SortValue.PRICE_ASC:
      return SortValue.PRICE_ASC;

    case SortValue.PRICE_DESC:
      return SortValue.PRICE_DESC;

    // case SortValue.MILEAGE_ASC:
    //   return SortValue.MILEAGE_ASC;

    // case SortValue.MILEAGE_DESC:
    //   return SortValue.MILEAGE_DESC;

    // case SortValue.YEAR_ASC:
    //   return SortValue.YEAR_ASC;

    // case SortValue.YEAR_DESC:
    //   return SortValue.YEAR_DESC;

    // ----- fallback -----
    default:
      return SortValue.LATEST;
  }
}

